const initialState = {
	list: [],
	filter: 'all',
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MAIL_GROUP_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.filter = action.payload.filter;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'MAIL_GROUP_ITEM_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.pic === action.payload.pic);
		if (index >= 0) {
			if (action.payload.type === 'confirmed') {
				newState.list[index].mail_unconfirmed_cnt = 0;
			}
			else if (action.payload.type === 'del') {
				newState.list.splice( index, 1 );
			}
		}
		return newState;
	}
	if (action.type === 'MAIL_GROUP_LIST_DATETIME_INIT') {
		let newState = Object.assign({}, state);
		newState.datetime = null;
		return newState;
	}
	else {
		return state;
	}
}
